import { styled } from "@mui/material/styles";

/** Wraps wide content (tables, code blocks) in a horizontal scroll container. */
export const ScrollContainer = styled("div")({
  overflowX: "auto",
});
